export const joinTeamOptions = [
    { value: 'Product designer', label: 'Product designer' },
    { value: 'UX Content Strategist', label: 'UX Content Strategist' },
    { value: 'Service designer', label: 'Service designer' },
    { value: 'UX Researcher', label: 'UX Researcher' },
    { value: 'Back-end Developer', label: 'Back-end Developer' },
    { value: 'Front-end Developers', label: 'Front-end Developers' },
    { value: 'Fullstack Developers', label: 'Fullstack Developers' },
    { value: 'Cloud Engineer', label: 'Cloud Engineer' },
    { value: 'Cloud Architect', label: 'Cloud Architect' },
    { value: 'DevOps Engineer', label: 'DevOps Engineer' },
]